<template>
  <tr class="practice-row">
    <td class="practice-col">
      <lazy-image
        :src="user.thumbnailUrl"
        :fallback="require('@/assets/loggedPlaceholder96x96.png')"
        :alt="user.name"
        wrapperClass="practice__avatar"
      />
    </td>
    <td class="practice-col">
      <h4 @click="$emit('to-user', user.id)" class="practice__name">
        {{ user.name }}
        <v-chip
          v-if="user.tenantDomain"
          x-small
          color="accent"
          class="mb-1 ml-2"
        >
          White label
        </v-chip>
      </h4>
      <span class="pr-2">{{ user.isActive ? 'Active' : 'Inactive' }}</span>
    </td>
    <td class="practice-col">
      <strong>{{ user.type }}</strong>
    </td>
    <td class="practice-col">
      <strong class="accent--text text-number">{{
        user.practitionersNo
      }}</strong>
    </td>
    <td class="practice-col">
      <strong class="bhGreen1--text text-number">{{
        user.participantsNo
      }}</strong>
    </td>
    <td class="practice-col">
      <p class="pr-2 mb-1 accent--text">
        {{ user.pcFirstName }} {{ user.pcLastName }}
      </p>
      <!-- <span class="bhGray2--text text-nowrap">
        Company
      </span> -->
    </td>
    <td class="practice-col">
      <span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment('MMMM Do, YYYY') }}
      </span>
    </td>
    <td class="practice-col">
      <span class="bhGray2--text text-nowrap">
        <!-- {{ user.modifyDate | moment("MMMM Do, YYYY")}} -->
      </span>
    </td>
    <td class="practice-col">
      <v-btn
        icon
        color="accent"
        elevation="0"
        @click="$emit('to-user', user.id)"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import LazyImage from '../lazy/LazyImage.vue'
export default {
  components: { LazyImage },
  name: 'PracticeTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="scss">
.practice {
  &__name {
    // what about wrapping names?
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;

    // do we hant hover style?
    // &:hover {
    //   text-decoration: underline;
    // }
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    .v-image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
